import { isExpired } from "react-jwt";
import GuestListActions from '../../actions/GuestListActions';
import PosActions from '../../actions/PosActions';
import AuthActions from '../../actions/AuthActions';
import NotificationActions from '../../actions/NotificationActions';
import UserStore from '../../stores/UserStore';
import GuestListStore from '../../stores/GuestListStore';
import PopupStore from '../../stores/PopupStore';
import RoutingStore from '../../stores/RoutingStore';
import GLBiotrack from './GLBiotrack.react';
import GLHeader from './GLHeader.react';
import GLLocation from './GLLocation.react';
import GLRegister from './GLRegister.react';
import GLSearch from './GLSearch.react';
import GLSettings from './GLSettings.react';
import GLSidebar from './GLSidebar.react';
import GLSystemStatus from './GLSystemStatus.react';
import GLTransactions from './GLTransactions.react';
import List from './List.react';
import NewAnonProfile from './NewAnonProfile.react';
import NewProfile from './NewProfile.react';
import GLSettingsVG from './settings/GLSettingsDPH.react';
import Cookies from 'universal-cookie';
import UserApi from '../../api/UserApi'
import DutchieRegisterToggle from './DutchieRegisterToggle.react';

const defaultToggleCopy = {
  header: 'On Nov 1, LeafLogix officially becomes Dutchie Register 🎉',
  description:
    'For a smooth transition, start using Dutchie Register today to get familiar before we retire LeafLogix.',
};


class GuestList extends React.Component {

    constructor(props) {
        super(props);

        var userStore = UserStore.getState();
        var listStore = GuestListStore.getState();

        this.state = {
            page: listStore.page,
            guestList: listStore.guestList,
            statusList: listStore.statusList,
            rooms: userStore.rooms,
            selectedRoom: userStore.selectedRoom,
            selectedRoomArr: userStore.selectedRoomArr,
            locations: userStore.locations,
            selectedLocation: userStore.selectedLocation,
            registers: userStore.registers,
            selectedRegister: userStore.selectedRegister,
            transactionId: listStore.transactionId,
            guest: listStore.guest,
            guestListHubConnection: undefined,
            isPusherEnabled: false,
            pusher: undefined,
            pusherChannelName: '',
            pusherKey: '',
            pusherCluster: '',
            pusherLocation: 0,
            toggleSetting: userStore.ldFlags['pos.dutchie-v1-toggle'] || 'Off',
            toggleCopy: userStore.ldFlags['pos.dutchie-toggle-copy'] || defaultToggleCopy,
        };

        this.onUserStoreChange = this.onUserStoreChange.bind(this);
        this.onGuestListStoreChange = this.onGuestListStoreChange.bind(this);
        this.onRoutingStoreChange = this.onRoutingStoreChange.bind(this);
        this.onPopupStoreChange = this.onPopupStoreChange.bind(this);
        this.onPageChange = this.onPageChange.bind(this);
        this.onNewPusherMessages = this.onNewPusherMessages.bind(this);
        this.onToggleClick = this.onToggleClick.bind(this);
    }

    componentDidMount() {

        UserStore.addChangeListener(this.onUserStoreChange);
        GuestListStore.addChangeListener(this.onGuestListStoreChange);
        GuestListStore.addPageChangeListener(this.onPageChange);
        RoutingStore.addChangeListener(this.onRoutingStoreChange);
        PopupStore.addChangeListener(this.onPopupStoreChange);

        GuestListActions.loadGuestList(false);
        GuestListActions.getStatusList();
        setTimeout(() => {
            PosActions.toggleSidebar(false);
        }, 100)

        if(UserStore.getState().selectedLocation) {
            this.connectPusher();
        }
    }

    componentWillUnmount() {
        UserStore.removeChangeListener(this.onUserStoreChange);
        GuestListStore.removeChangeListener(this.onGuestListStoreChange);
        RoutingStore.removeChangeListener(this.onRoutingStoreChange);
        PopupStore.removeChangeListener(this.onPopupStoreChange);
        GuestListStore.removeChangeListener(this.onPageChange);
        if (this.state.guestListHubConnection && this.state.guestListHubConnection.state === 'Connected') {
            this.state.guestListHubConnection.stop();
        }

        if (this.state.selectedLocation.UseSmartCheckin && this.state.pusher && this.state.pusher.connection.state === 'connected') {
            this.disconnectPusher();
        }
    }

    connectPusher() {
        const pusherConf = GuestListActions.getPusherConfiguration();
        pusherConf.then(res => {
            this.setState({
                pusherChannelName: res.Data.ChannelName,
                pusherKey: res.Data.PusherKey,
                pusherCluster: res.Data.PusherCluster
            }, () => {
                this.addPusherScript();
            })
        })
    }

    async addPusherScript() {
        const script = document.createElement("script");
        script.src = "https://js.pusher.com/7.0.3/pusher.min.js";
        script.type = "text/javascript";
        script.async = true;
        script.onload = () => {
            const pusher = new Pusher(this.state.pusherKey, {
                cluster: this.state.pusherCluster,
                authorizer: function (channel, options) {
                    return {
                        authorize: function (socketId, callback) {
                            const authString = GuestListActions.authPusherChannel(socketId);
                            authString.then(res => {
                                callback(null, { auth: res.Data.auth });
                            })

                        }
                    };
                }
            });
            this.setState({ pusher: pusher });
            pusher.connection.bind("state_change", function (states) {
                if (states.current === 'connected') {
                    GuestListActions.notifyPusherConnected();
                } else {
                    GuestListActions.notifyConnectionLost();
                }
            });
            const channel = pusher.subscribe(this.state.pusherChannelName);
            channel.bind("checkin", (data) => this.onNewPusherMessages(data, "checkin"))
            channel.bind("checkout", (data) => this.onNewPusherMessages(data, "checkout"))
            channel.bind("checkoutByTransactionId", (data) => this.onNewPusherMessages(data, "checkoutByTransactionId"))
            channel.bind("updateGuest", (data) => this.onNewPusherMessages(data, "updateGuest"))
            this.setState({ isPusherEnabled: true, pusher: pusher });

        }
        document.body.appendChild(script);
    }

    onNewPusherMessages(data, event) {
        if (event === 'checkin') {
            GuestListActions.addOrUpdateGuest(JSON.parse(data));
        } else if (event === 'checkout') {
            GuestListActions.removeGuest(data);
        } else if (event === 'checkoutByTransactionId') {
            GuestListActions.removeGuestByTransactionId(data);
        } else if (event === 'updateGuest') {
            GuestListActions.addOrUpdateGuest(JSON.parse(data));
        }
    }

    disconnectPusher(){
        //Do this because otherwise get get a react error
        //Invariant Violation: Cannot dispatch in the middle of a dispatch.
        setTimeout(() => {
            try {
                this.state.pusher.disconnect();
            } catch (e) {
                console.error(e)
            }
        }, 1)
    }

    onUserStoreChange() {
        var store = UserStore.getState();
        if (this.state.selectedLocation.location_id != store.selectedLocation.location_id) {
            GuestListActions.loadGuestList();
            GuestListActions.getStatusList();
            if (this.state.selectedLocation.UseSmartCheckin && this.state.pusher && this.state.pusher.connection.state === 'connected') {
                this.disconnectPusher()
            }
            this.connectPusher();
        }


        this.setState({
            rooms            : store.rooms,
            selectedRoom     : store.selectedRoom,
            selectedRoomArr  : store.selectedRoomArr,
            locations        : store.locations,
            selectedLocation : store.selectedLocation,
            registers        : store.registers,
            selectedRegister : store.selectedRegister,
            toggleSetting       : store.ldFlags['pos.dutchie-v1-toggle'] || 'Off',
            toggleCopy:       store.ldFlags['pos.dutchie-toggle-copy'] || defaultToggleCopy,
        });
    }

    onPageChange() {
        var store = GuestListStore.getState();
        this.setState({
            page: store.page,
            transactionId: store.transactionId,
            guestId: store.guestId
        });

        if(store.page === 'register'){
            sessionStorage.removeItem('toggleDismissed');
        }
    }

    onGuestListStoreChange() {
        var store = GuestListStore.getState();
        this.setState({
            guestList: store.guestList,
            statusList: store.statusList,
            page: store.page
        });
    }

    onRoutingStoreChange(route) {
    }

    onPopupStoreChange({ page, data, guest }) {
        if (!page && !data && !guest && this.state.selectedLocation) {
            GuestListStore.setPage('list');
        }
    }

    checkTokenExpiration() {
        if (isExpired(this.state.signalRConnectionDetails.AccessToken)) {
            GuestListActions.connectToSignalR();
        }
    }

    onToggleClick() {
        localStorage.removeItem('v1OptOut');
        AuthActions.goToDutchieRegister(UserStore.getApiData(), true);
    }


    render() {
        var self = this;

        var route = this.props.route;
        var user = this.props.user;
        var guestList = this.state.guestList;
        var page = this.state.page;
        var guest = this.state.guest;
        var transactionId = this.state.transactionId;
        return (

            <div className='guest-list'>


                <GLHeader
                    onSearch={() => { GuestListStore.setPage('search') }}
                    page={page}
                    guest={guest}
                    transactionId={transactionId}
                    guestList={guestList}
                    newProfile={(data) => {
                        GuestListStore.setPage('new-profile');
                        self.refs.NewProfile.setPatientData(data);
                    }}
                />

                <GLSidebar
                    page={page}
                    selectedLocation={this.state.selectedLocation}
                    locations={this.state.locations}
                    selectedRegister={this.state.selectedRegister}
                    registers={this.state.registers}
                    goToPage={(page) => { GuestListStore.setPage(page) }}
                />
                <List
                    page={page}
                    user={user}
                    guestList={guestList}
                    rooms={this.state.rooms}
                    selectedRoom={this.state.selectedRoom}
                    selectedRoomArr={this.state.selectedRoomArr}
                    selectedLocation={this.state.selectedLocation}
                    selectedRegister={this.state.selectedRegister}
                    statusList={this.state.statusList} />

                <GLSearch
                    page={page} />

                <GLLocation
                    page={page}
                    user={user}
                    locations={this.state.locations}
                    selectedLocation={this.state.selectedLocation} />

                <GLRegister
                    page={page}
                    selectedLocation={this.state.selectedLocation}
                    registers={this.state.registers}
                    selectedRegister={this.state.selectedRegister}
                    onSelect={() => { GuestListStore.setPage('list') }}
                />

                {
                    this.state.selectedLocation.CanUseMassDPHIntegration &&
                    <GLSettingsVG
                        page={page}
                        selectedLocation={this.state.selectedLocation}
                        user={user}
                    />
                }

                <NewProfile
                    page={page}
                    ref='NewProfile' />

                <NewAnonProfile
                    page={page}
                    ref='NewAnonProfile' />

                <GLBiotrack
                    page={page} />

                {page === 'close-out' &&
                    <GLTransactions
                        page={page}
                        selectedRegister={this.state.selectedRegister} />
                }

                {this.state.selectedLocation &&
                    <GLSettings
                        page={page}
                        user={user}
                        selectedLocation={this.state.selectedLocation} />
                }

                {this.state.selectedLocation &&
                    <GLSystemStatus
                        page={page}
                        user={user}
                        selectedLocation={this.state.selectedLocation} />
                }

                { this.state.selectedLocation && this.state.toggleSetting !== 'Off' &&
                    <DutchieRegisterToggle toggleCopy={this.state.toggleCopy} checked={false} onClick={this.onToggleClick}>
                    </DutchieRegisterToggle>
                }
            </div>
        );
    }
}
export default GuestList;



// WEBPACK FOOTER //
// ./ui_src/app/components/guest-list/GuestList.react.jsx